import Dictionary from './modules/dictionary'
import Response from './modules/response'
import Responses from './modules/responses'
import Settings from './modules/settings'
import Shop from './modules/settingsShop'
import User from './modules/user'
import Tags from './modules/tags'
import Statuses from './modules/statuses'
import Vacancies from './modules/vacancies'

export default {
  namespaced: true,
  modules: {
    Dictionary,
    Response,
    Responses,
    Settings,
    Shop,
    User,
    Tags,
    Statuses,
    Vacancies
  }
}
